import { optionsMap } from 'pro-gallery-lib';
import { PRIVATE_CONTROLLERS } from './common/private-controllers';
export var settingsOptions = {
    settingTab: [
        optionsMap.behaviourParams.item.clickAction,
        optionsMap.behaviourParams.gallery.layoutDirection,
    ],
    VideoTab: [
        optionsMap.behaviourParams.item.video.enablePlayButton,
        optionsMap.behaviourParams.item.video.playTrigger,
        optionsMap.behaviourParams.item.video.speed,
        optionsMap.behaviourParams.item.video.volume,
        optionsMap.behaviourParams.item.video.loop,
    ],
    animationTab: [
        optionsMap.behaviourParams.item.content.hoverAnimation,
        optionsMap.behaviourParams.item.content.placementAnimation,
        optionsMap.behaviourParams.gallery.scrollAnimation,
        optionsMap.behaviourParams.gallery.horizontal.slideAnimation,
    ],
    info: [
        optionsMap.layoutParams.info.placement,
        optionsMap.behaviourParams.item.overlay.hoveringBehaviour,
        [PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE],
        [PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION],
        optionsMap.layoutParams.info.sizeUnits,
        optionsMap.layoutParams.info.height,
        [PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL],
        [PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT],
        [PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN],
        [PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING],
        [PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN],
        [PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING],
        'OVERLAY',
        PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE,
        optionsMap.behaviourParams.item.overlay.sizeUnits,
        PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT,
        PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL,
        optionsMap.behaviourParams.item.overlay.position,
        optionsMap.behaviourParams.item.overlay.padding,
        optionsMap.behaviourParams.item.overlay.hoverAnimation
    ],
};
//# sourceMappingURL=settingsOptions.js.map